import {
  expaGetClientSideExpaFromCookie,
  expaGetClientSideFrozenExpaFromCookie,
  expaSetClientSideFrozenExpaCookie,
} from '../../expa'

export const cartIntermediateFreezeExpaCookie = (): void => {
  const expaCookie = expaGetClientSideExpaFromCookie()
  const frozenExpa = expaGetClientSideFrozenExpaFromCookie()
  if (expaCookie && !frozenExpa) {
    expaSetClientSideFrozenExpaCookie(expaCookie)
  }
}
